const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Slack settings component
 * @argument {Application} Application injected to gain access to the global Application service
 * @argument {CompanyIntegrations} CompanyIntegrations injected to gain access to the Company Integrations
 */
app.directive('slackSettings', ['Application', 'CompanyIntegrations', 'SlackIntegrate', function (Application, CompanyIntegrations, SlackIntegrate) {
  return {
    restrict: "E",
    replace: true,
    scope : {
      'modalactive': '=?',
      'type': '@?'
    },
    template: require('../../templates/directives/slack-settings.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var urlParams = Application.navigation.getUrlParameters();
      self.type = 'standard';
      if ($scope.type === 'eddy' || urlParams.type === 'eddy') {
        self.type = 'eddy';
      }

      self.slackLink = self.type === 'standard' ? Application.slackLink : Application.eddySlackLink;

      // Optional Enterprise Grid workspace targeting: extract a Slack team ID
      // from whatever the admin pastes — a raw ID (T0123ABCD) or any URL
      // containing one (e.g. app.slack.com/client/T0123ABCD/...).
      self.workspaceInput = '';
      self.targetTeamId = function() {
        var input = (self.workspaceInput || '').toUpperCase();
        var match = input.match(/(?:^|[^A-Z0-9])(T[A-Z0-9]{5,})/);
        return match ? match[1] : null;
      };

      // Authorize link with the workspace pre-selected on Slack's consent
      // screen (&team=). Without a target, Slack shows its own picker.
      self.installLink = function() {
        var teamId = self.targetTeamId();
        return self.slackLink && teamId ? self.slackLink + '&team=' + teamId : self.slackLink;
      };

      self.toggleModalActive = function(){
        $scope.modalactive = !$scope.modalactive;
      };

      self.checkParams = function() {
        var params = Application.navigation.getUrlParameters();
        if (params.code) {
          const createReq = self.type === 'standard' ? SlackIntegrate.create : SlackIntegrate.createEddy;

          createReq({}, {
            code: params.code,
            // The HMAC-signed CSRF state minted by the API rides along from the
            // OAuth authorize link through Slack and the API relay back to this
            // page; the API validates it on the callback POST and derives the
            // token-exchange redirect_uri server-side.
            state: params.state
          }, function(data) {
            self.hasSlack = true;
            self.slackNeedsUpdate = false;
            // Re-fetch status so the connected-workspace details reflect the
            // install that just completed.
            self.loadStatus();

            Application.messaging.addMessage({type: 'success', text: 'Slack Configured!', druation: 5});
            // Application.navigation.goTo('/overview/settings', {});
          }, function(err) {
            console.log('error in making slack integration: ', err)
            Application.navigation.goTo('/overview/settings/integrations', {});
          });
        } else if (params.error) {
          // Consent denial forwarded by the API relay (user canceled on
          // Slack's consent screen) — there is no code to exchange. The toast
          // template renders via ng-bind-html, so only echo the error when it
          // looks like an OAuth error code, not arbitrary URL input.
          var slackError = /^[\w.-]+$/.test(params.error) ? ' (' + params.error + ')' : '';
          Application.messaging.addMessage({type: 'error', text: 'Slack authorization was canceled' + slackError + '.', duration: 5});
        }

      };

      self.uninstall = function() {
        self.uninstalling = true;

        SlackIntegrate.uninstall({}).$promise
        .then(function(results) {
          if (results.status === 'ok') {
            self.hasSlack = false;
            self.slackNeedsUpdate = false;
            self.workspace = null;
          }
          self.uninstalling = false;
          self.showUninstall = false;
        }).catch(function(error) {
          console.log('error: ', error);
          self.uninstalling = false;
        });
      };
      
      self.loadStatus = function (done) {
        CompanyIntegrations.status({}, function (data) {
          self.companyIntegration = data || {};
          self.hasSlack = self.type === 'eddy' ? self.companyIntegration.eddySlack : self.companyIntegration.slack;
          self.slackNeedsUpdate = self.companyIntegration.slackNeedsUpdate;
          self.workspace = self.type === 'eddy' ? self.companyIntegration.eddySlackWorkspace : self.companyIntegration.slackWorkspace;

          if (done) {
            done();
          }
        }, function (error) {
          console.log('Error occured getting company integration ', error);
        });
      };

      self.initialize = function () {
        self.loadStatus(self.checkParams);
      };
      self.initialize();
    }],
    controllerAs: 'slack'
  }
}]);
